import { PropsWithChildren, ReactElement } from "react";
import useAttention from "../../useAttention";
import AttentionIndicator from "../AttentionIndicator/AttentionIndicator";

interface IProps {
    /**
     * What the badge meant before Just nu existed. On the responsive header this
     * is unread chat plus unread notifications, so turning the number into a
     * Just nu count must not lose the fact that a message is waiting — it becomes
     * the dot.
     */
    unreadCount: number;

    /**
     * What to show where Just nu is not this person's. Keeps the caller's own
     * badge rather than inventing one.
     */
    fallback: ReactElement | null;
}

/**
 * The badge on the responsive menu button.
 *
 * The small viewport has no bell, so the hamburger carries the number instead.
 * Same rule as the bell: the count is what there is to do, unread is a dot.
 */
function AttentionMenuBadge(props: PropsWithChildren<IProps>): ReactElement {
    const { unreadCount, fallback, children } = props;

    const { list } = useAttention();

    if (!list?.applicable) {
        return (
            <>
                {children}
                {fallback}
            </>
        );
    }

    return (
        <AttentionIndicator
            count={list.count}
            overdueCount={list.rows.filter((row) => row.isOverdue).length}
            unreadCount={unreadCount}
        >
            {children}
        </AttentionIndicator>
    );
}

export default AttentionMenuBadge;
